var _circle, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    stroke: "#9E9E9E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4911 11.2419L24.8005 9.90861L24.1338 8.75391L21.8244 10.0872L22.4911 11.2419Z",
    fill: "#9E9E9E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88835 14.8868H6.22168V13.5535H8.88835V14.8868Z",
    fill: "#9E9E9E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7772 14.8868H23.1106V13.5535H25.7772V14.8868Z",
    fill: "#9E9E9E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50764 11.2419L7.19824 9.90861L7.86491 8.75391L10.1743 10.0872L9.50764 11.2419Z",
    fill: "#9E9E9E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4439 22.8867C16.4439 23.9913 15.5485 24.8867 14.4439 24.8867C13.3393 24.8867 12.4439 23.9913 12.4439 22.8867C12.4439 22.653 12.484 22.4286 12.5577 22.2201H16.3301C16.4038 22.4286 16.4439 22.653 16.4439 22.8867Z",
    fill: "#9E9E9E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9998 9.27353V8.44141C13.9998 7.33684 14.8952 6.44141 15.9998 6.44141C17.1044 6.44141 17.9998 7.33684 17.9998 8.44141V9.27353C19.9543 10.0647 21.3331 11.9809 21.3331 14.2192V18.2192C21.3331 18.9556 21.9301 19.5525 22.6664 19.5525H23.1109V22.2192H8.88867V19.5525H9.33312C10.0695 19.5525 10.6664 18.9556 10.6664 18.2192V14.2192C10.6664 11.9809 12.0452 10.0647 13.9998 9.27353ZM15.3331 8.44141C15.3331 8.07322 15.6316 7.77474 15.9998 7.77474C16.368 7.77474 16.6664 8.07322 16.6664 8.44141V8.92711C16.4481 8.89988 16.2256 8.88585 15.9998 8.88585C15.774 8.88585 15.5515 8.89988 15.3331 8.92711V8.44141ZM11.9998 18.2192V14.2192C11.9998 12.01 13.7906 10.2192 15.9998 10.2192C18.2089 10.2192 19.9998 12.01 19.9998 14.2192V18.2192C19.9998 19.3803 20.7418 20.368 21.7776 20.7341V20.8859H10.222V20.7341C11.2577 20.368 11.9998 19.3803 11.9998 18.2192Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.36e72fe21ea718323ff7fe8a1ff1a0d1.svg";
export { ForwardRef as ReactComponent };